import { PC_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  @media screen and (min-width: ${PC_LAYOUT_LENGTH}) {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -999;
  }
`;

export const Design1 = styled.div`
  @media screen and (min-width: ${PC_LAYOUT_LENGTH}) {
    position: absolute;
    width: 90rem;
    height: 90rem;
    left: 1.8rem;
    top: -16.9rem;

    background: radial-gradient(50% 50% at 50% 50%, rgba(246, 33, 225, 0.3) 0%, rgba(246, 33, 225, 0) 100%);
    filter: blur(20rem);
  }
`;
export const Design2 = styled.div`
  @media screen and (min-width: ${PC_LAYOUT_LENGTH}) {
    position: absolute;
    width: 70rem;
    height: 70rem;
    left: 40rem;
    top: 12.6rem;

    background: radial-gradient(50% 50% at 50% 50%, rgba(33, 195, 246, 0.3) 0%, rgba(33, 195, 246, 0) 100%);
    filter: blur(20rem);
  }
`;
export const Design3 = styled.div`
  @media screen and (min-width: ${PC_LAYOUT_LENGTH}) {
    position: absolute;
    width: 80rem;
    height: 80rem;
    left: 67.4rem;
    top: 0.3rem;

    background: radial-gradient(50% 50% at 50% 50%, rgba(33, 246, 80, 0.3) 0%, rgba(33, 246, 80, 0) 100%);
    filter: blur(20rem);
  }
`;
export const Design4 = styled.div``;
